import React from "react";

const imgs = [
  { iphase: "Video Tutorial", igid: "xitem8", vid: "sgaHowTo.mp4" },
];

export default function HowTo() {
  return (
    <div className="flex flex-col items-center w-full">
      <h1 className="text-3xl font-bold text-center my-6">
        How To Use SpiritGuideAstrology
      </h1>

     <div className="xgrid-container2 grid gap-4 my-4 place-items-center">
        {imgs.map((e) => (
          <div key={e.igid} className={`gallery-container w-1 h-1 ${e.igid}`}>
            <div className="gallery-item">
              <a href={e.vid}>
                <div className="image relative">
                  <img
                    src="images/JackHopkinsSGA.jpg"
                    className="img_ctr"
                    alt="Jack Hopkins"
                  />
                  <div className="toverlay2 absolute inset-0 flex items-center justify-center">
                    <div className="toverlay-text2 text-center">
                      <h2>{e.iphase}</h2>
                    </div>
                  </div>
                </div>
                <div className="text text-center mt-2">{e.iphase}</div>
              </a>
            </div>
          </div>
        ))}
      </div>

      <Section title="Guest Access">
        <p>
          Everyone has read-only Guest Access to the public charts we have
          included on this site.
        </p>
        <p>
          To look at charts and get predictions, select the Menu Icon at the
          upper-left-hand corner and pick Charts.
        </p>
        <p>
          Start typing in the last name of any chart you wish to see. A list will
          popup below — just select the one you want.
        </p>
        <p>
          You can also click on aspects, interps, or timeline below the chart to
          get more details and interpretations.
        </p>
        <p>
          If you get stuck, you can always click on SpiritGuideAstrology in the
          title bar to start over.
        </p>
        <p>
          Colors — Black: Direct • Red: Retrograde • Purple: Out Of Bounds •
          Green: Out of Bounds + Retrograde
        </p>
        <p>
          Some charts contain events. If you see a dropdown next to the chart
          name, you can select from a set of events. Use the arrow buttons to
          move back and forth through the timeline.
        </p>
      </Section>

      <Section title="Sun and Moon">
        <p>
          To the right of the chart you will see the type of chart displayed. Below
          that are details on the Sun and Moon: the 60th Harmonic sign and 360th
          Harmonic sign for the Sun, the Lunar Phase for the Moon, and its 4th
          Harmonic sign in the 28-phase lunar cycle. For more information, visit
          the Jack Hopkins Author page on Amazon Books.
        </p>
      </Section>

      <Section title="How Do I Find My Lunar/Solar Phase?">
        <p>
          Lunar phase and Sun subphase can be found by selecting "Sun & Moon" from
          the Main Menu. This will give you a text description including Lunar
          Phase Number. You can also watch a video of your phase by selecting
          "Lunar Phases" and choosing the corresponding phase.
        </p>
      </Section>

      <Section title="Entering Your Own Charts">
        <p>
          If you want to manage your own charts, you will need to sign up and log
          in. It's free and you only need to do it once.
        </p>
        <p>
          The system remembers your login unless you clear your browser cache or
          switch browsers.
        </p>
        <p>Once signed in, select the menu icon and log in with your email.</p>
        <p>
          After logging in, the New Chart option will appear. Enter the birth
          chart data; longitude and latitude will auto‑fill after entering
          date/time and city/state.
        </p>
      </Section>

      <Section title="Getting Predictions">
        <p>
          To run predictions, click the gear icon next to the chart name. Choose
          from Transits, Lunations, 100 Days, Solar Arcs, Secondary/Tertiary
          progressions, and more.
        </p>
        <p>
          S2 Moon allows you to step through the secondary‑progressed Moon.
        </p>
        <p>
          Tran2Tran tracks transiting planets only, useful for current events.
        </p>
        <p>
          Arrow buttons jump between predicted events, and the "interps" tab gives
          more info.
        </p>
        <p>
          Many prediction options include a graphical timeline across your date
          range.
        </p>
      </Section>

      <Section title="Events Timeline">
        <p>
          Some charts have an event timeline based on tertiary progressions. Colors
          relate to the four elements according to the 60th harmonic of the
          progressed Sun.
        </p>
        <p>
          Not all charts include a timeline — type the first letter of a last name
          to see which ones do.
        </p>
      </Section>

      <Section title="What Are Those P3s? (Advanced)">
        <p>
          P3 stands for tertiary progressions. P3 options for Mercury, Venus, and
          Mars return lifetime events using tertiary progressions.
        </p>
        <p>Pay close attention to their retrograde periods.</p>
      </Section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="w-full max-w-4xl px-4 my-8 text-lg leading-relaxed">
      <h1 className="text-2xl font-bold text-center mb-4">{title}</h1>
      {children}
    </div>
  );
}

